{
  "deprecatedBrowser": "Ihr Browser wird nicht unterstützt",
  "deprecatedBrowserHelpText": "Aktualisieren Sie Ihren Browser auf die aktuelle Version, um ihn optimal nutzen zu können."
}
